<template>
  <!--员工管理-->
  <div>
    <div class="goods-head">
      <div class="slider-list">
        <div class="item selected">员工管理11111</div>
      </div>
      <!-- 查询表单  -->
      <div class="goods-head-form">
        <div class="fileds">
          <el-form ref="ruleForm" :inline="true" :model="formInline" class="demo-form-inline">
            <el-row>
              <!-- <el-form-item prop="userName" label="用户名">
                <el-input v-model="formInline.userName" placeholder="请输入" />
              </el-form-item> -->
              <el-form-item prop="realName" label="员工姓名">
                <el-input v-model.trim="formInline.realName" placeholder="请输入" />
              </el-form-item>
              <el-form-item prop="phone" label="手机号">
                <el-input v-model.trim="formInline.phone" placeholder="请输入" />
              </el-form-item>
              <el-form-item prop="isAdmin" label="管理级别">
                <el-select v-model="formInline.isAdmin" placeholder="请选择">
                  <el-option v-for="item in dict.isAdmin" :key="item.id" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-row>
            <!-- <el-row>
              <el-form-item prop="isAdmin" label="管理级别">
                <el-select v-model="formInline.isAdmin" placeholder="请选择">
                  <el-option v-for="item in dict.isAdmin" :key="item.id" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-row> -->
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="query"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm('ruleForm')"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>
    <!--表格操作-->
    <section class="operations clearfloat">
      <template>
        <div class="operations-add" @click="addPopClick">
          <i class="iconfont iconjia" />
          新增
        </div>
        <div class="operations-del" @click="batchDel">
          <i class="iconfont iconshanchu" />
          批量删除
        </div>
        <div class="operations-recommend" @click="initParss">
          <i class="iconfont iconelite" />
          初始化密码
        </div>
      </template>
    </section>
    <!--表格-->
    <section class="main">
      <!--表格头部-->
      <article class="main-header">
        <ul>
          <li>
            <el-checkbox v-model="allSelection" @change="selection()" />
          </li>
          <li>公司名称</li>
          <li>员工姓名</li>
          <li>用户名</li>
          <li>管理级别</li>
          <li>职业类型</li>
          <li>联系电话</li>
          <li>操作</li>
        </ul>
      </article>
      <!--表格内容-->
      <article class="main-body">
        <template v-if="tableData.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item, itemIndex) in tableData">
          <div :key="itemIndex" class="body-item">
            <ul>
              <li>
                <el-checkbox v-model="item.selection" @change="change()" />
              </li>
              <li>{{ item.companyName }}</li>
              <li>{{ item.realName }}</li>
              <li>{{ item.userName }}</li>
              <li>{{ item.isAdmingValue }}</li>
              <li>{{ item.userPostName }}</li>
              <li>{{ item.phone }}</li>
              <li>
                <el-button type="text" @click="addRecordClick(item)">设置权限</el-button>
                <el-divider direction="vertical" />
                <el-button type="text" @click="popEdit(item)">编辑</el-button>
                <el-divider direction="vertical" />
                <el-button type="text" @click="tableDelete(item.userId)">删除</el-button>

                <el-button plain size="small" @click="active == itemIndex ? active = -1 : active = itemIndex">
                  详情
                  <i :class="{'expand': active == itemIndex ? true : false}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <businessDetails v-if="active == itemIndex" class="businessIf" :details="item" />
          </div>
        </template>
      </article>
      <!--分页-->
      <article class="main-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </article>
    </section>
    <!--新增弹窗-->
    <el-dialog
      :visible.sync="addPop"
      title="新增员工"
      width="900px"
      @close="addPop = false"
    >
      <addEdit v-if="addPop" :usertype="userType" type="add" @click="addEditClick" />
    </el-dialog>
    <!--编辑弹窗-->
    <el-dialog
      :visible.sync="editPop"
      :title="el_dialong"
      width="900px"
    >
      <!-- <textasd :pop-data="popData" /> -->
      <addEdit v-if="editPop" type="edit" :usertype="userType" :pop-data="popData" @click="addEditClick" />
    </el-dialog>
    <!--设置权限-->
    <el-dialog
      :visible.sync="addRecordPop"
      title="设置权限"
      width="900px"
    >
      <authority v-if="addRecordPop" :usertype="userType" :pop-data="popData" @click="success" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDict } from '@/api/common'
import { staffAll } from '@/api/personal/enterprise'
import businessDetails from '../components/business-contacts'
import addEdit from './addEdit'
import authority from './authority'
import { Page } from '@/utils/commonDataModel'
import inputFilter from '@/directives/validation/index.js'
import { getList } from '@/api/personal/enterprise/sponsor/index.js'

export default {
  components: {
    businessDetails,
    addEdit,
    authority
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  directives: {
    inputFilter
  },
  data() {
    return {
      // 详情显示隐藏
      active: -1,
      // 字典
      dict: {
        isAdmin: [],
        postType: []
      },
      // 搜索条件表单
      formInline: {
        userName: '',
        realName: '',
        phone: '',
        isAdmin: ''
      },

      // 全选状态
      allSelection: false,
      // 表格数据
      tableData: [],

      // 新增业务弹窗状态
      addPop: false,

      // 编辑弹窗
      editPop: false,
      // 编辑数据回显
      popData: {},

      // 设置权限弹窗
      addRecordPop: false,

      // 表格分页
      pagination: new Page(),
      // 获取用户信息
      userType: '',
      el_dialong:''
    }
  },
  watch: {
    'popData.userId': {
      handler(val) {
      },
      deep: true
    }
  },
  created() {
    this.staffAll()
    this.getDict('isAdmin')
    this.getDict('postType')
   
  
  },
  mounted() {
    this.userType = this.userInfo.userType
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.query()
      }
    }
  },
  methods: {
    // 获取字典
    getDict(type) {
      getDict(type).then(res => {
        this.dict[type] = JSON.parse(res.result)
      })
    },
    // 全选
    selection() {
      this.tableData.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 子项多选
    change() {
      this.allSelection = this.tableData.every(i => i.selection)
    },
    // 表格编辑按钮
    popEdit(item) {
      this.el_dialong='编辑'
      this.popData = item
      this.editPop = true
    },
    // 查询按钮
    query() {
      this.staffAll()
    },
    // 批量删除
    batchDel() {
      this.delUser(this.getId())
    },
    // 获取id
    getId() {
      const arr = this.tableData.map(ele => {
        if (ele.selection) return ele.userId
      })
      const userId = arr.filter(n => n).join(',')
      console.log(userId)
      return userId
    },
    // 表格删除按钮
    tableDelete(userId) {
      this.delUser(userId)
    },
    // 删除方法
    delUser(userId) {
      if (userId == '') {
        this.$message({
          message: '请选择删除的数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('此操作将删除选中数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 确认删除
        staffAll({
          methodName: 'batchDel',
          userId
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.staffAll()
        })
      })
    },

    // 添加或编辑成功回调
    addEditClick({ data, type }) {
      switch (type) {
        case 'add':
          this.addEditFn({ methodName: 'saveSysUser', pwdLevel: '3', ...data }).then(res => {
            this.addPop = false // 关闭弹窗
            this.staffAll()
          })
          break
        case 'edit':
          this.addEditFn({ methodName: 'updateSysUser', ...data }).then(res => {
            this.editPop = false // 关闭弹窗
            this.staffAll()
          })
          break
          case 'close':
          console.log("closecloseclosecloseclose")
                this.editPop = false // 关闭弹窗
                    this.addPop = false // 关闭弹窗
          break
        default:
          return
      }
    },
    // 设置权限
    addRecordClick(item) {
      // this.popData = item
      // this.addRecordPop = true
      this.el_dialong='设置权限'
      this.popData = item
      this.editPop = true
    },
    // 设置权限提交按钮
    success(params) {
      staffAll({
        methodName: 'setEmpleAuth',
        ...params
      }).then(res => {
        this.addRecordPop = false
        this.staffAll()
        this.$message({
          type: 'success',
          message: '修改成功'
        })
      })
    },
    // 重置表单
    resetForm() {
      this.formInline.realName = ''
      this.formInline.phone = ''
      this.formInline.isAdmin = ''
      this.staffAll()
    },

    // 新增
    addPopClick(formName) {
      // 根据id查询出对应列表
      this.addPop = true
    },
    // 分页-第几页
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.staffAll()
    },
    // 分页-每页多少条
    changeSize(size) {
      this.pagination = new Page()
      this.pagination.pageSize = size
      this.staffAll()
    },
    // 查询
    staffAll() {
      for (const i in this.formInline) {
        this.formInline[i] = this.formInline[i].replace(/\s+/g, '')
      }
      staffAll({
        methodName: 'findList',
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.pageNo,
        ...this.formInline
      }).then(res => {
        console.log(res)
        this.pagination.total = res.result.total
        if (res.result.rows) this.tableData = this.attSelection(res.result.rows)
      })
    },
    // 给所有数据添加selection
    attSelection(list) {
      return list.map(ele => {
        ele.selection = false
        return ele
      })
    },
    // 获取详情 *没有使用
    getDetails(userId) {
      staffAll({
        methodName: 'getUserDetails',
        userId
      }).then(res => {
        this.details = res.result.rows
      })
    },
    // 新增 OR 修改
    addEditFn(params) {
      return staffAll({
        ...params
      })
    },
    // 初始化密码
    initParss() {
      const userId = this.getId()
      if (userId == '') {
        this.$message({
          message: '请选择要初始化密码的用户',
          type: 'warning'
        })
        return
      }
      staffAll({
        methodName: 'batchChangePwd',
        pwdLevel: '3',
        userId
      }).then(res => {
        this.staffAll()
        this.$message({
          type: 'success',
          message: '初始化密码成功'
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  $main-color: #be2316;

  .goods-head {
    padding: 12px 12px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    width: 928px;
    border: 1px solid #DDDDDD;
    /deep/.rowone{
      margin-bottom: 10px;
    }
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .goods-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 80%;
        /deep/ .el-form-item {
          width: 230px;
          margin-bottom: 0;
          label:after {
            content: " : ";
          }
          .el-input__inner{
            width: 140px;
          }
        }
      }
      .buttons {
        flex: 0 1 20%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .operations {
    margin: 16px 0px;
    .operations-add{
      float: left;
      width: 90px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      text-align: center;
      background-color: #BE2316;
      border-color: #F56C6C;
      border-radius: 3px;
      cursor: pointer;
      margin-right: 10px;
      i{
        vertical-align: bottom;
      }
      color: #fff;
    }
    .operations-del{
      float: left;
      width: 90px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      text-align: center;
      background-color: #BE2316;
      border-color: #F56C6C;
      border-radius: 3px;
      cursor: pointer;
      margin-right: 10px;
      i{
        vertical-align: bottom;
      }
      color: #fff;
    }
    .operations-recommend{
      float: left;
      width: 100px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      text-align: center;
      background-color: #BE2316;
      border-color: #F56C6C;
      border-radius: 3px;
      cursor: pointer;
      i{
        vertical-align: bottom;
      }
      color: #fff;
    }
  }
  .main{
    .main-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      width: 928px;
      height: 51px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      ul {
        display: flex;
        flex-wrap: nowrap;
        line-height: 51px;
        box-sizing: content-box;
        li {
          font-size: 14px;
          min-width: 50px;
          margin: auto auto;
          text-align: center;
          &:first-child {
            flex-basis: 5%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 15%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 15%;
          }
          &:last-child {
            flex-basis: 20% !important;
          }
        }
      }
    }
    .main-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }
      .body-item {
        width: 928px;
        height: auto;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
        border-radius: 4px;
        margin: 8px 0px;
        position: relative;
        box-sizing: border-box;

        ul {
          display: flex;
          flex-wrap: nowrap;
          width: 100%;
          min-height: 83px;
          // height: 83px;
          position: relative;
          background-color: white;
          font-weight:400;
          color:rgba(51,51,51,1);

          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            margin: auto auto;
            text-align: center;
            position: relative;
            &:first-child {
              flex-basis: 5%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
              color: #333;
            }
            &:nth-child(3) {
              flex-basis: 10%;
              color: #333;
            }
            &:nth-child(4) {
              flex-basis: 15%;
              color: #555;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 15%;
            }
            &:last-child {
              flex-basis: 20% !important;
              .el-button:first-child {
                color: #E08402 !important;
              }
              .el-button:nth-child(3) {
                color: #555555 !important;
              }
              .el-button:nth-child(5) {
                color: #296FEE !important;
              }
              .el-button:nth-child(7) {
                color: #BF2316 !important;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: .5s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .main-pagination{
      width: 100%;
      padding: 16px 0px;
      margin-top: 24px;
      background-color: white;
      box-sizing: border-box;
      border: 1px solid #DDDDDD;
    }
  }
</style>
